define(() => {
    "use strict";

    return {
        NONE: "none",
        STRETCH: "stretch",
        DEFAULT: "default"
    };
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/WidgetScaleMode.js